import React, { useState, useEffect } from 'react';
import { getFavorites } from '../utils/favorites';
import RecipeCard from '../components/RecipeCard';
import RecipeModal from '../components/RecipeModal';
import { Heart, HeartOff, Home, Grid3X3 } from 'lucide-react';

function Favorites({ favorites, onFavoriteChange }) {
    const [selectedRecipe, setSelectedRecipe] = useState(null);
    const [localFavorites, setLocalFavorites] = useState([]);

    useEffect(() => {
        // Update local favorites when prop changes or on mount
        const currentFavorites = favorites || getFavorites();
        setLocalFavorites(currentFavorites);
    }, [favorites]);

    const handleViewDetails = (recipe) => {
        setSelectedRecipe(recipe);
    };

    const handleCloseModal = () => {
        setSelectedRecipe(null);
    };

    const handleFavoriteChange = (newFavorites) => {
        setLocalFavorites(newFavorites);
        if (onFavoriteChange) {
            onFavoriteChange(newFavorites);
        }
    };

    return (
        <div className="favorites">
            <div className="container">
                <div className="page-header">
                    <Heart className="page-icon" />
                    <h1>Your Saved Recipes</h1>
                    <p>
                        {localFavorites.length === 0
                            ? "No favorites saved yet"
                            : `${localFavorites.length} recipe${localFavorites.length === 1 ? '' : 's'} saved`
                        }
                    </p>
                </div>

                {localFavorites.length === 0 ? (
                    <div className="empty-favorites">
                        <div className="empty-favorites-content">
                            <HeartOff className="empty-icon" size={64} />
                            <h3>No favorites yet!</h3>
                            <p>
                                Start exploring recipes and add them to your favorites by clicking the heart icon.
                            </p>
                            <div className="empty-actions">
                                <a href="/" className="cta-button">
                                    <Home size={18} />
                                    Discover Recipes
                                </a>
                                <a href="/categories" className="secondary-button">
                                    <Grid3X3 size={18} />
                                    Browse Categories
                                </a>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="recipes-grid">
                        {localFavorites.map(recipe => (
                            <RecipeCard
                                key={recipe.idMeal}
                                recipe={recipe}
                                onViewDetails={handleViewDetails}
                                onFavoriteChange={handleFavoriteChange}
                            />
                        ))}
                    </div>
                )}
            </div>

            {selectedRecipe && (
                <RecipeModal
                    recipe={selectedRecipe}
                    onClose={handleCloseModal}
                    onFavoriteChange={handleFavoriteChange}
                />
            )}
        </div>
    );
}

export default Favorites;